import { Dialog, DialogTitle, DialogContent } from '@mui/material';

interface PopupProps {
  title: string;
  children: {};
  openPopup: boolean;
  setOpenPopup: (bool: boolean) => void;
}

function Popup(props: PopupProps) {
  const { title, children, openPopup, setOpenPopup } = props;
  return (
    <Dialog
      disableRestoreFocus={true}
      open={openPopup}
      onClose={() => {
        setOpenPopup(false);
      }}
      maxWidth="md"
    >
      <DialogTitle>
        <b>{title}</b>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}

export default Popup;
